import { Account } from "./account";
import { ManagerDetails } from "./managerDetails";

export class Manager {
    managerId : number;
    managerDetails :ManagerDetails;
    account : Account;

    constructor() {
        this.managerId = 0;
        this.managerDetails = new ManagerDetails();
        this.account = new Account();
    }
}